export default "__VITE_ASSET__CSD_uTj3__"